import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Uppy from '@uppy/core';
import FileInput from '@uppy/file-input';
import XHRUpload from '@uppy/xhr-upload';
import cn from 'classnames';
import '@uppy/drag-drop/dist/style.css';
import './textbox-button-upload-files.scss';

import avatarUploadEmpty from '../../assets/images/upload/avatar-upload.svg';
import './avatar-upload.scss';


class AvatarUpload extends Component {
	state = {
		previewImage: '',
	};

	componentDidMount() {
		const {
			uppyTarget, urlUpload, authService, userStore, intl, handleFileChange, showValidationMessage,
		} = this.props;

		this.uppy
			.use(FileInput, {
				target: `.${uppyTarget}`,
				replaceTargetContent: true,
				locale: {
					strings: {
						chooseFiles: intl.formatMessage({ id: 'userPersonalInfo.upload_photo' }),
					},
				},
			})
			.use(XHRUpload, {
				endpoint: urlUpload,
				fieldName: 'file',
				headers: {
					Authorization: `Bearer ${authService.getAccessToken()}`,
					'X-Group': userStore.profile.id,
				},
			})
			.on('complete', (result) => {
				result.successful.map((successfulFile) => {
					handleFileChange(successfulFile.response.body.url);

					this.setState({
						previewImage: successfulFile.response.body.url,
					});

					return successfulFile;
				});
			})
			.on('info-visible', () => {
				const { type, message } = this.uppy.getState().info;
				showValidationMessage({ code: 'avatar-upload', color: type, message });
			});
	}


	componentDidUpdate(prevProps) {
		const { intl } = this.props;

		this.uppy.getPlugin('FileInput').translator.locale.strings = {
			chooseFiles: intl.formatMessage({
				id: 'userPersonalInfo.upload_photo',
			}),
		};

		this.uppy.getPlugin('FileInput').update();

		if (prevProps.selectedGroup !== this.props.selectedGroup){
			this.setState({
				previewImage: null,
			});
		}
	}

	uppy = new Uppy({
		autoProceed: true,
		restrictions: {
			allowedFileTypes: this.props.validFormats,
		},
		onBeforeFileAdded: (currentFile) => {
			const fileLowerCase = { ...currentFile };
			fileLowerCase.name = fileLowerCase.name.toLowerCase();
			return fileLowerCase;
		},
	});

	render() {
		const { previewImage } = this.state;
		const {
			uppyTarget, previousAvatar, initials, disabled,
		} = this.props;

		return (
			<div className="avatar-upload">
				<div className={cn('img-wrapper',
					{ emptyPictureInitials: (!previousAvatar && initials) })}
				>
					{
						(previewImage || previousAvatar) ? (
							<div
								style={{ backgroundImage: `url(${previewImage || previousAvatar})` }}
								className="rounded-circle img"
								title=""
							/>
						)
							: (
								initials
									? (
										<span>
											{initials}
										</span>
									)
									: (
										<div
											style={{ backgroundImage: `url(${avatarUploadEmpty})` }}
											className="rounded-circle img"
											title=""
										/>
									)
							)
					}
				</div>
				<div className="label-content">
					<div>
						<span className="avatar-info">
							<FormattedMessage id="userPersonalInfo.profile_picture" />
						</span>
					</div>
					<div>
						<strong className={cn('avatar-upload-btn', { disabled })}>
							<div className={uppyTarget} />
						</strong>
					</div>
				</div>
			</div>
		);
	}
}

export default inject('authService', 'userStore')(injectIntl(AvatarUpload));
